import { Key } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";

const LeaseNegotiations = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Landlord/Tenant Lease Negotiation Services</h2>
          <p className="text-lg text-muted-foreground">
            Skilled legal representation for drafting, reviewing, and negotiating residential and commercial lease agreements in Houston, Texas. We protect both landlords and tenants by ensuring fair terms, compliance with Texas law, and clear understanding of rights and obligations.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Lease Negotiations" subtitle="Professional Lease Agreement Services" icon={<Key className="h-16 w-16" />} mainContent={mainContent} />;
};
export default LeaseNegotiations;